import {
  ISite,
  OPEN_MODAL_POPUP,
  CLOSE_MODAL_POPUP,
  PopupInner,
} from "../types/siteTypes";
import { getPreferredCurrencyFromLanguage } from "../utils/currency";

const initialState: ISite = {
  popupOpen: false,
  popupInner: PopupInner.LogIn,
  currency: getPreferredCurrencyFromLanguage(),
};

export default function siteReducer(state: ISite = initialState, action: any) {
  switch (action.type) {
    case OPEN_MODAL_POPUP:
      return { popupOpen: true, popupInner: action.popupInner };
    case CLOSE_MODAL_POPUP:
      return { popupOpen: false };
    default:
      return state;
  }
}
